import React from 'react'
import { formatDate, formatDateUTC, isValidDate } from 'sidecar-utility-library'

import { Date, Day, Month, Year } from './styles'

const Component = ({ className, date, defaultValue = '', utc = false }) =>
  isValidDate(date) ? (
    <Date className={className}>
      <Month>
        {utc ? formatDateUTC('MMM', date) : formatDate('MMM', date)}
      </Month>
      <Day>{utc ? formatDateUTC('DD', date) : formatDate('DD', date)}</Day>
      <Year>
        {utc ? formatDateUTC('YYYY', date) : formatDate('YYYY', date)}
      </Year>
    </Date>
  ) : (
    defaultValue
  )

Component.displayName = 'DateStack'

export default Component
